module.exports = __webpack_public_path__ + "img/arrow-left-circle-fill.a48336a8.svg";